import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {RecommendationModel} from "../../../models/recommendation.model";
import {Direction} from "@angular/cdk/bidi";

require('./recommendations-list-items.scss');
@Component({
  standalone: false,
  selector: 'app-recommendations-list-items',
  templateUrl: './recommendations-list-items.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecommendationsListItemsComponent implements OnChanges {
  @Input() direction: Direction = 'ltr';
  @Input() showRecommendationLink: boolean = true;
  @Input() recommendations: RecommendationModel[];
  @Input() loading: boolean;

  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() updateRecommendation = new EventEmitter<RecommendationModel>();
  @Output() goToRecommendation = new EventEmitter<RecommendationModel>();
  @Output() markRecommendationAsRead = new EventEmitter<RecommendationModel>();
  @Output() applyRecommendation = new EventEmitter<RecommendationModel>();
  @Output() openRoutePanelsByIds = new EventEmitter<string[]>();
  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  private hasRequestedNextBatch = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.recommendations) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
      // Reset flag when new data arrives
      if (changes.recommendations.currentValue !== changes.recommendations.previousValue) {
        this.hasRequestedNextBatch = false;

        if (!changes.recommendations.isFirstChange()){
          const previousLength = changes.recommendations.previousValue.length || 0;
          const currentLength = changes.recommendations.currentValue.length || 0;

          if (currentLength && previousLength > currentLength) {
            setTimeout(() => {
              this.checkIfUnderfilled();
            });
          }
        }
      }
    }

    // Reset flag when loading completes
    if (changes.loading && !changes.loading.currentValue && changes.loading.previousValue) {
      this.hasRequestedNextBatch = false;
    }
  }

  getNextBatch() {
    // Prevent multiple calls: check if loading, already requested, or not near bottom
    if (this.loading || this.hasRequestedNextBatch) {
      return;
    }

    const bottomOffset = this.cdkVirtualScrollViewport.measureScrollOffset('bottom');

    if (bottomOffset < 200) {
      this.hasRequestedNextBatch = true;
      this.fetchNextEvent.emit();
    }
  }

  private checkIfUnderfilled() {
    if (this.loading || this.hasRequestedNextBatch || !this.cdkVirtualScrollViewport) {
      return;
    }

    const viewportElement = this.cdkVirtualScrollViewport.elementRef.nativeElement;
    const isScrollable = viewportElement.scrollHeight > viewportElement.clientHeight;

    if (!isScrollable && this.recommendations && this.recommendations.length > 0) {
      this.hasRequestedNextBatch = true;
      this.fetchNextEvent.emit();
    }
  }

  trackById(_: number, item: RecommendationModel): string {
    return item.id;
  }
}

